import { render, staticRenderFns } from "./SideGuide.vue?vue&type=template&id=16d31050&scoped=true&"
import script from "./SideGuide.vue?vue&type=script&lang=ts&"
export * from "./SideGuide.vue?vue&type=script&lang=ts&"
import style0 from "./SideGuide.vue?vue&type=style&index=0&id=16d31050&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d31050",
  null
  
)

export default component.exports